import { DataLogStatus } from 'store/app/enums';
import { VatRunData } from 'store/vat/models';
import { VatReportData } from 'store/vat/models/vatReportData';

export const isUnsavedDraftRun = (vatRunData: VatRunData): boolean => {
  if (!vatRunData.dataLogId) {
    return true;
  }
  if (!vatRunData.status) {
    return true;
  }
  const status = DataLogStatus[vatRunData.status];
  return (
    status === DataLogStatus.NOT_SAVED ||
    status === DataLogStatus.NOT_STARTED ||
    status === DataLogStatus.EXCEPTIONS_MODIFIED
  );
};

/** The return is on screen: the VAT payload loaded, or generation finished.
 * TIFD has no VAT payload, including after the report is saved. */
export const hasReportWorkflowContext = (
  _vatRunData: VatRunData,
  vatReportData: VatReportData | undefined,
  generationSucceeded: boolean
): boolean => {
  if (vatReportData) {
    return true;
  }
  return generationSucceeded;
};
